import { render, staticRenderFns } from "./SearchResultAItem.vue?vue&type=template&id=fcb92056&"
import script from "./SearchResultAItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultAItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports